import React from 'react';
import { Card } from '@/components/ui/card';
import { X, AlertCircle, CheckCircle2 } from 'lucide-react';

interface MessageCardProps {
  type: 'success' | 'error';
  message: string;
  onDismiss: () => void;
}

export const MessageCard: React.FC<MessageCardProps> = ({
  type,
  message,
  onDismiss,
}) => {
  const isSuccess = type === 'success';
  const bgColor = isSuccess ? 'bg-green-50 border-green-200' : 'bg-red-50 border-red-200';
  const textColor = isSuccess ? 'text-green-600' : 'text-red-600';
  const messageColor = isSuccess ? 'text-green-800' : 'text-red-800';
  const Icon = isSuccess ? CheckCircle2 : AlertCircle;

  return (
    <Card className={`p-3 sm:p-4 ${bgColor}`}>
      <div className="flex items-start gap-2 sm:gap-3">
        <Icon className={`h-4 w-4 sm:h-5 sm:w-5 ${textColor} shrink-0 mt-0.5`} />
        <div className="flex-1 min-w-0">
          <p className={`text-sm sm:text-base ${messageColor}`}>{message}</p>
        </div>
        <button
          onClick={onDismiss}
          className={`shrink-0 ${textColor} hover:opacity-80`}
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </Card>
  );
};

